import React from 'react';
import {Grid, Col, Row} from 'react-bootstrap';


class Infobox extends React.Component {




  render () {
    let {info} = this.props

    let total = 0

    if(info){
     total = info.total ? info.total : 0
    }





    return (
          <div style={style.container}>

          <Grid>
            <Row style={style.row}>
              <b  style={style.number}>{total}</b><p style={style.numberLabel}>Stories</p>
             </Row>
          </Grid>


          </div>
    );
  }

}

const style = {
                container:{
                  // height: 280,
                  paddingTop:35, //1 px minimum, long story.. probably, this is faster
                  color:'#444444',
                  fontSize:'14px',
                  paddingLeft:20
                },

                number:{
                  fontSize: 'x-large',
                  color:'#111'
                },
                numberLabel:{
                  color:'#999',
                  fontWeight: 600
                },

                row:{
                  margin:0,
                  // padding: 30
                }
              }

module.exports = Infobox
